import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, MessageSquare, FileText } from 'lucide-react';

interface MobileNumberActionsProps {
    mobileNumber: string;
    customerUuid: string;
    onSMSClick: () => void;
}

const MobileNumberActions: React.FC<MobileNumberActionsProps> = ({ mobileNumber, customerUuid, onSMSClick }) => {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        // Allow middle-click / ctrl-click to open in new tab
        if (e.button === 1 || e.ctrlKey || e.metaKey) return;
        e.preventDefault();
        setIsOpen((prev) => !prev);
    };

    return (
        <div className="relative inline-block" ref={dropdownRef}>
            <a
                href={`/customer/${customerUuid}`}
                onClick={handleLinkClick}
                className="text-indigo-600 hover:text-indigo-800 font-medium cursor-pointer"
            >
                {mobileNumber}
            </a>

            {isOpen && (
                <div className="absolute left-0 mt-1 w-48 bg-white rounded-md shadow-lg border border-gray-200 z-50">
                    <button
                        onClick={() => {
                            setIsOpen(false);
                            navigate(`/show-lease/${customerUuid}`);
                        }}
                        className="flex items-center gap-2 w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-t-md"
                    >
                        <FileText className="w-4 h-4" />
                        View Leases
                    </button>
                    <button
                        onClick={() => {
                            setIsOpen(false);
                            navigate(`/customer/${customerUuid}`);
                        }}
                        className="flex items-center gap-2 w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >
                        <Eye className="w-4 h-4" />
                        View Details
                    </button>
                    <button
                        onClick={() => {
                            setIsOpen(false);
                            onSMSClick();
                        }}
                        className="flex items-center gap-2 w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-b-md"
                    >
                        <MessageSquare className="w-4 h-4" />
                        Send SMS
                    </button>
                </div>
            )}
        </div>
    );
};

export default MobileNumberActions;
